export default __webpack_public_path__ + "static/media/brand-2.2fe9bb95.png";